import React from "react";

const About = () => {
  return (
    <div style={{marginTop:"150px"}}>
      <h1>About</h1>
      <p>Welcome to the Phone Book App!</p>
    </div>
  );
}

export default About;